(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2150,5442,5223],{

/***/ 9695:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[mobileOrDesktop]/[hostname]/order",
      function () {
        return __webpack_require__(89794);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SsgFallback; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59848);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80805);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function SsgFallback() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().loading)
        })
    });
};


/***/ }),

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8165);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Loading(props) {
    var height = props.height || 200;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        style: {
            height: height
        }
    });
};


/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54731);
/* harmony import */ var _hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1626);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18899);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








function Button(props, ref) {
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loadingState = _$ref[0], setLoading = _$ref[1];
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var loading = props.loading || loadingState;
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), confirm = _$ref1[0], setConfirm = _$ref1[1];
    var overrideOnClickRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var darkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var onClick = function() {
        var _ref = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(props.disabled || loading)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!props.confirmText) {
                            _ctx.next = 9;
                            break;
                        }
                        if (!confirm) {
                            _ctx.next = 7;
                            break;
                        }
                        {
                            setConfirm(false);
                        }
                        _ctx.next = 9;
                        break;
                    case 7:
                        setConfirm(true);
                        return _ctx.abrupt("return");
                    case 9:
                        setLoading(true);
                        if (!overrideOnClickRef.current) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 13;
                        return overrideOnClickRef.current();
                    case 13:
                        _ctx.next = 21;
                        break;
                    case 15:
                        if (!props.onClick) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 18;
                        return props.onClick();
                    case 18:
                        _ctx.next = 21;
                        break;
                    case 20:
                        if (props.to) {
                            router.push(props.to);
                        }
                    case 21:
                        // check if button is mounted
                        if (buttonRef.current) {
                            setLoading(false);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var setOnClick = function(onClick) {
        overrideOnClickRef.current = onClick;
    };
    var _clickOnKey;
    (0,_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_clickOnKey = props.clickOnKey) !== null && _clickOnKey !== void 0 ? _clickOnKey : "none", function() {
        if (!props.disabled && !loading && props.clickOnKey) {
            onClick();
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, function() {
        return {
            onClick: onClick,
            setOnClick: setOnClick,
            click: onClick,
            focus: function() {
                if (buttonRef.current) {
                    buttonRef.current.focus();
                }
            }
        };
    });
    var style = props.disabled ? "disabled" : props.primary ? "primary" : props.danger ? "danger" : props.contrast ? "contrast" : "default";
    var size = props.small ? "small" : props.extraBig ? "extraBig" : props.big ? "big" : "default";
    var className = classnames__WEBPACK_IMPORTED_MODULE_5___default()({
        "inline-flex justify-center items-center shadow-sm rounded": true,
        "font-semibold": true,
        "transition ease-in-out duration-150": true,
        "focus:outline-none focus:ring-2 focus:ring-offset-2": true,
        "px-4 py-2 text-sm": size === "default",
        "px-4 py-1 text-sm": size === "small",
        "px-5 py-3 text-md": size === "big",
        "px-5 py-4 text-md": size === "extraBig",
        "cursor-not-allowed": props.disabled,
        "w-full": props.full,
        "!border-gray-100 text-gray-400": style === "disabled",
        "border-gray-100 text-gray-700": style === "default",
        "text-white": style === "primary" || style === "danger",
        "focus:ring-gray-300": style === "default",
        "focus:button-v3-primary": style === "primary",
        "focus:ring-red-500": style === "danger",
        "bg-gray-100 border-gray-100": style === "disabled" || style === "default",
        "bg-red-500 border-red-500": style === "danger",
        "button-v3-primary": style === "primary",
        "bg-gray-900 border-gray-900 text-white": style === "contrast" && !darkMode,
        "bg-white border-white text-gray-900": style === "contrast" && darkMode,
        "hover:bg-gray-200": !loading && style === "default" || style === "contrast" && darkMode && !loading,
        "hover:button-v3-primary": !loading && style === "primary",
        "hover:bg-red-400": !loading && style === "danger",
        "hover:bg-gray-300": style === "contrast" && !darkMode && !loading
    }, props.className);
    var _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
        ref: buttonRef,
        type: (_type = props.type) !== null && _type !== void 0 ? _type : "submit",
        form: "formId",
        disabled: props.disabled || loading,
        onClick: onClick,
        className: className,
        children: [
            !loading && props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(props.icon, {
                className: "-ml-0.5 mr-2 w-4",
                "aria-hidden": "true"
            }) : null,
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: "mr-3",
                color: style === "default" ? "gray" : "white"
            }) : null,
            confirm ? props.confirmText : props.children
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(Button));


/***/ }),

/***/ 18899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SpinnerLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function SpinnerLoading(props) {
    var color = props.color || "gray";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, {
            "h-5 w-5": !props.size || props.size === "sm",
            "h-4 w-4": props.size === "xs",
            "h-6 w-6": props.size === "md",
            "h-8 w-8": props.size === "lg",
            "h-10 w-10": props.size === "xl",
            "animate-spin": true,
            "text-white": color === "white",
            "text-gray-500": color === "gray",
            "text-blue-500": color === "blue" || color === "primary",
            "text-green-500": color === "green",
            "text-red-500": color === "red",
            "text-yellow-500": color === "yellow",
            "text-black": color === "black"
        }),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};


/***/ }),

/***/ 89894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((classnames__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ 62280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getQueryObject; }
/* harmony export */ });
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17673);

function getQueryObject(router) {
    var ref;
    var queryString = (ref = router.asPath.split("?")[1]) !== null && ref !== void 0 ? ref : "";
    return (0,querystring__WEBPACK_IMPORTED_MODULE_0__.parse)(queryString);
};


/***/ }),

/***/ 49343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsStore; }
});

;// CONCATENATED MODULE: ./src/helpers/websites/isStore.ts
function isStore(businessType) {
    return businessType === "store";
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/helpers/misc/WebsiteBusinessTypeContext.ts

/* harmony default export */ var WebsiteBusinessTypeContext = (react.createContext(null));

// EXTERNAL MODULE: ./src/helpers/websites/getDomain.ts
var getDomain = __webpack_require__(15141);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/hooks/useWebsiteBusinessType.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getWebsiteBusinessTypeFromDomain_cached($domain: String) {\n        website(domain: $domain) {\n          _id\n          businessType\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useWebsiteBusinessType() {
    var businessType = (0,react.useContext)(WebsiteBusinessTypeContext);
    var website = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            domain: (0,getDomain/* default */.Z)()
        },
        fetchPolicy: "cache-first",
        omit: (0,isServerSide/* default */.Z)(),
        partial: true
    }).website;
    if (businessType) return businessType;
    if (!website || !(0,getDomain/* default */.Z)()) return null;
    return website.businessType;
};

;// CONCATENATED MODULE: ./src/hooks/useIsStore.ts


function useIsStore(website) {
    var businessType = useWebsiteBusinessType();
    if (website === null || website === void 0 ? void 0 : website.businessType) {
        businessType = website.businessType;
    }
    return isStore(businessType);
};


/***/ }),

/***/ 1626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyboardEvent(combination, callback) {
    var keysToMatch = combination.toLowerCase().split("+");
    var keys = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    callbackRef.current = callback;
    var checkEvent = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysToMatch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var keyToMatch = _step.value;
                if (!keys[keyToMatch]) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callbackRef.current();
    };
    var onKeyDown = function(event) {
        if (event && event.key) {
            var key = event.key.toLowerCase();
            keys[key] = true;
        }
    };
    var onKeyUp = function(event) {
        if (event && event.key) {
            checkEvent();
            var key = event.key.toLowerCase();
            delete keys[key];
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keyup", onKeyUp);
        document.addEventListener("keydown", onKeyDown);
        return function() {
            document.removeEventListener("keyup", onKeyUp);
            document.removeEventListener("keydown", onKeyDown);
        };
    });
};


/***/ }),

/***/ 5528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMessage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_contexts_ShowMessageContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59325);


function useMessage() {
    var showMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_packages_justo_parts_lib_contexts_ShowMessageContext__WEBPACK_IMPORTED_MODULE_1__["default"]);
    return showMessage;
};


/***/ }),

/***/ 65017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useMyOrderPreferencesWithDefault; }
});

// EXTERNAL MODULE: ./src/data/fragments/preferences/appOrderPreferences.main.ts + 3 modules
var appOrderPreferences_main = __webpack_require__(2134);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/queries/preferences/getMyOrderPreferences.main.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getMyOrderPreferences($websiteId: ID) {\n    preferences: userPreferences(websiteId: $websiteId) {\n      ...appOrderPreferences\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getMyOrderPreferencesQuery = (0,lib["default"])(_templateObject(), appOrderPreferences_main/* default */.Z);
var useMyOrderPreferences = function(websiteId) {
    return (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getMyOrderPreferencesQuery,
        variables: {
            websiteId: websiteId
        },
        omit: (0,isServerSide/* default */.Z)() || !websiteId,
        fetchPolicy: "cache-first",
        partial: true
    });
};

;// CONCATENATED MODULE: ./src/hooks/useMyOrderPreferencesWithDefault.ts

/**
 * NOTE: This must be SSR Compatible (i.e. it must not suspend nor return user data)
 */ function useMyOrderPreferencesWithDefault(website) {
    var ref = useMyOrderPreferences(website._id), queriedPrefs = ref.preferences, networkStatus = ref.networkStatus;
    var preferences = queriedPrefs ? queriedPrefs : {
        menuId: website.defaultMenuId
    };
    return {
        preferences: preferences,
        loading: networkStatus <= 2 || !website
    };
};


/***/ }),

/***/ 47592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSharedPageRewriteHelper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62280);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



/**
 * When using a shared page for different routes (e.g. /order and /order/productId/productName),
 * we need to force the param (productId) into the router query object.
 * Unfortunatelly, when doing a rewrite in the middleware, the passed query vars are not available.
 * @param resourceKey the key to force onto the router (e.g. 'productId')
 * @param getResourceFromUrlFn a fn that parses the current path and returns the resource value (e.g. getProductIdFromUrl)
 * @returns the router
 */ function useSharedPageRewriteHelper(resourceKey, getResourceFromUrlFn) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // We use useEffect so that the cached SSR version does not render the resource. It should render the wrapper instead.
        var matchedResource = getResourceFromUrlFn(router.asPath);
        if (router.isReady && matchedResource && router.query[resourceKey] !== matchedResource) {
            var query = (0,_helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(router);
            router.replace({
                pathname: window.location.pathname,
                query: _objectSpread({}, query, _defineProperty({}, resourceKey, matchedResource))
            });
        }
    }, [
        router,
        resourceKey,
        getResourceFromUrlFn
    ]);
    return router;
};


/***/ }),

/***/ 25932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTrack; }
/* harmony export */ });
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation trackAction(\n            $type: String\n            $productId: ID\n            $orderId: ID\n            $path: String\n            $meta: JSON\n          ) {\n            trackAction(\n              type: $type\n              productId: $productId\n              orderId: $orderId\n              path: $path\n              meta: $meta\n            )\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useTrack() {
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useMutate */ .Tu)();
    var track = function() {
        var _ref = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(type, params) {
            return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
                            variables: _objectSpread({}, params, {
                                type: type
                            })
                        });
                    case 3:
                        _ctx.next = 7;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function track(type, params) {
            return _ref.apply(this, arguments);
        };
    }();
    return track;
};


/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* unused harmony exports DEFAULT_DESKTOP_WIDTH, DEFAULT_MOBILE_WIDTH */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95078);




var DEFAULT_DESKTOP_WIDTH = 1920;
var DEFAULT_MOBILE_WIDTH = 360;
function useWidth() {
    var ssrMobileOrDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ssrWidth = ssrMobileOrDesktop === "mobile" ? DEFAULT_MOBILE_WIDTH : DEFAULT_DESKTOP_WIDTH;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? ssrWidth : window.innerWidth), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function handler() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return width !== null && width !== void 0 ? width : ssrWidth;
};


/***/ }),

/***/ 23023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Example; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5434);
/* harmony import */ var _components_V3_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1555);



function Example() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "min-h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto max-w-max",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                    className: "sm:flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-4xl font-bold tracking-tight text-indigo-600 sm:text-5xl",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_2__/* .MdWifiOff */ .Em6, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "sm:ml-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "sm:border-l sm:border-gray-200 sm:pl-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                                            children: "Este sitio esta desactivado"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-1 text-base text-gray-500",
                                            children: "Para activarlo, contacta a cobranzas@getjusto.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_V3_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        primary: true,
                                        onClick: function() {
                                            return window.location.href = "https://getjusto.com";
                                        },
                                        children: "Ir a Justo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 25442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NoWebsite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43469);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function NoWebsite(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/no-website.svg",
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().image)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Este sitio web no est\xe1 configurado correctamente"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://getjusto.com",
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().logo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/logo-dark.svg"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 10177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RI": function() { return /* binding */ CartLoadingProvider; },
/* harmony export */   "k6": function() { return /* binding */ useCartLoading; }
/* harmony export */ });
/* unused harmony export CartLoadingContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var CartLoadingContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    loading: false,
    setLoading: function() {}
});
var useCartLoading = function() {
    return react__WEBPACK_IMPORTED_MODULE_1__.useContext(CartLoadingContext);
};
var CartLoadingProvider = function(param) {
    var children = param.children;
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), loading = ref[0], setLoading = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartLoadingContext.Provider, {
        value: {
            loading: loading,
            setLoading: setLoading
        },
        children: children
    });
};


/***/ }),

/***/ 31143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);



function LoadingProducts(param) {
    var fullScreen = param.fullScreen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            "col-xs-12 col-sm-6 col-md-8": !fullScreen,
            "col-xs-12": fullScreen
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col animate-pulse",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "my-9 h-14 w-full bg-gray-300 dark:bg-gray-600 rounded"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-1 mb-3 h-12 w-40 bg-gray-300 dark:bg-gray-600 rounded"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-1 h-6 w-24 bg-gray-300 dark:bg-gray-600 rounded"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative rounded-xl overflow-auto p-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row space-x-4",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row space-x-4 mt-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-1 mb-5 h-6 w-24 bg-gray-300 dark:bg-gray-600 rounded"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative rounded-xl overflow-auto p-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row space-x-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 88641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLayout; }
/* harmony export */ });
/* harmony import */ var _hooks_useWidth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9177);

function useLayout(website) {
    var width = (0,_hooks_useWidth__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();
    var isMobile = width < 768;
    if (website && website.menuLayout === "categories") return "categories";
    if (isMobile) return "mobile";
    if (!website) return "v2";
    if (!website.menuLayout) return "v2";
    return website.menuLayout;
};


/***/ }),

/***/ 41594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ OrderPreferencesContext; },
/* harmony export */   "Z": function() { return /* binding */ useOrderPreferences; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var OrderPreferencesContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
function useOrderPreferences() {
    var preferences = react__WEBPACK_IMPORTED_MODULE_0__.useContext(OrderPreferencesContext);
    return preferences;
};


/***/ }),

/***/ 66218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductsLayout; }
/* harmony export */ });
function useProductsLayout(website) {
    if (!website) return "long";
    return website.productsLayout || "long";
};


/***/ }),

/***/ 89794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ OrderPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/SsgFallback/index.tsx
var SsgFallback = __webpack_require__(19060);
// EXTERNAL MODULE: ./node_modules/next/server.js
var server = __webpack_require__(97385);
;// CONCATENATED MODULE: ./src/helpers/middleware/sharedPages/product.ts


var getProductIdFromOrderUrl = function(pathname) {
    var match = pathname.match(/^\/(order|pedir)\/([^\/\?]+)\/?([^\/]*)/);
    if (!match) return null;
    if (match[2] === "category") return null;
    return match[2];
};
var rewriteProduct = function(url, pathname, mobileOrDesktop, hostname) {
    var productId = getProductIdFromOrderUrl(pathname);
    if (productId) {
        url.pathname = "".concat(getTenantPath(mobileOrDesktop, hostname), "/order");
        url.searchParams.set("productId", productId);
        return NextResponse.rewrite(url);
    }
    return null;
};

// EXTERNAL MODULE: ./src/hooks/useSharedPageRewriteHelper.ts
var useSharedPageRewriteHelper = __webpack_require__(47592);
// EXTERNAL MODULE: ./src/page-components/DeactivatedByDebt/index.tsx
var DeactivatedByDebt = __webpack_require__(23023);
// EXTERNAL MODULE: ./src/page-components/Layout/AbstractLayout.tsx + 27 modules
var AbstractLayout = __webpack_require__(66344);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/index.tsx + 18 modules
var Website = __webpack_require__(20151);
// EXTERNAL MODULE: ./src/page-components/NoWebsite/index.tsx
var NoWebsite = __webpack_require__(25442);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/Loading.tsx
var Loading = __webpack_require__(53762);
// EXTERNAL MODULE: ./src/helpers/events/index.ts
var events = __webpack_require__(52860);
// EXTERNAL MODULE: ./src/hooks/useMyOrderPreferencesWithDefault.ts + 1 modules
var useMyOrderPreferencesWithDefault = __webpack_require__(65017);
// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Loading/index.tsx
var ProductsContent_Loading = __webpack_require__(31143);
// EXTERNAL MODULE: ./src/page-components/Order/CartLoadingContext.tsx
var CartLoadingContext = __webpack_require__(10177);
// EXTERNAL MODULE: ./src/hooks/useIsStore.ts + 3 modules
var useIsStore = __webpack_require__(49343);
;// CONCATENATED MODULE: ./src/page-components/Order/LongOrCompactLayout.tsx



var LongOrCompactCPG = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(7447), __webpack_require__.e(1888), __webpack_require__.e(615), __webpack_require__.e(6748), __webpack_require__.e(4366), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(6381), __webpack_require__.e(4980), __webpack_require__.e(5870), __webpack_require__.e(4271), __webpack_require__.e(6535), __webpack_require__.e(4493), __webpack_require__.e(9374)]).then(__webpack_require__.bind(__webpack_require__, 57476));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57476)
            ];
        }
    }
});
var Products = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(7447), __webpack_require__.e(1888), __webpack_require__.e(615), __webpack_require__.e(6748), __webpack_require__.e(4366), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(6381), __webpack_require__.e(4980), __webpack_require__.e(5870), __webpack_require__.e(4271), __webpack_require__.e(6535), __webpack_require__.e(4493), __webpack_require__.e(809)]).then(__webpack_require__.bind(__webpack_require__, 68156));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68156)
            ];
        }
    }
});
function LongOrCompactLayout(props) {
    var ref, ref1;
    var website = props.website, layout = props.layout, menuId = props.menuId, nextOpenDate = props.nextOpenDate, preferences = props.preferences, productCardDesign = props.productCardDesign, categories = props.categories, productsLayout = props.productsLayout, loading = props.loading;
    var isStore = (0,useIsStore/* default */.Z)();
    return isStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LongOrCompactCPG, {
        website: website,
        productsLayout: productsLayout,
        layout: layout,
        menuId: menuId,
        loading: loading,
        nextOpenDate: nextOpenDate,
        preferences: preferences,
        productCardDesign: productCardDesign,
        storeId: preferences === null || preferences === void 0 ? void 0 : (ref = preferences.store) === null || ref === void 0 ? void 0 : ref._id,
        deliverAt: preferences === null || preferences === void 0 ? void 0 : preferences.deliverAt
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, {
        website: website,
        productsLayout: productsLayout,
        layout: layout,
        menuId: menuId,
        loading: loading,
        nextOpenDate: nextOpenDate,
        preferences: preferences,
        productCardDesign: productCardDesign,
        preloadedCategories: categories,
        storeId: preferences === null || preferences === void 0 ? void 0 : (ref1 = preferences.store) === null || ref1 === void 0 ? void 0 : ref1._id,
        deliverAt: preferences === null || preferences === void 0 ? void 0 : preferences.deliverAt
    });
};

// EXTERNAL MODULE: ./src/hooks/useTrack.ts
var useTrack = __webpack_require__(25932);
;// CONCATENATED MODULE: ./src/page-components/Order/Track.ts


function Track() {
    var track = (0,useTrack/* default */.Z)();
    (0,react.useEffect)(function() {
        track("viewMenu");
    }, []) // Only on mount
    ;
    return null;
};

// EXTERNAL MODULE: ./src/page-components/Order/useLayout.ts
var useLayout = __webpack_require__(88641);
// EXTERNAL MODULE: ./src/page-components/Order/useOrderPreferences.ts
var useOrderPreferences = __webpack_require__(41594);
// EXTERNAL MODULE: ./src/page-components/Order/useProductsLayout.ts
var useProductsLayout = __webpack_require__(66218);
// EXTERNAL MODULE: ./src/page-components/Order/styles.module.css
var styles_module = __webpack_require__(43872);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



















var OnTableModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5295).then(__webpack_require__.bind(__webpack_require__, 15295));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15295)
            ];
        }
    },
    ssr: false
});
var PageMeta = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8264).then(__webpack_require__.bind(__webpack_require__, 98264));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98264)
            ];
        }
    },
    ssr: false
});
var Page = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1877).then(__webpack_require__.bind(__webpack_require__, 57907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57907)
            ];
        }
    },
    ssr: false
});
var Cart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(7447), __webpack_require__.e(1888), __webpack_require__.e(615), __webpack_require__.e(6748), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(6381), __webpack_require__.e(4980), __webpack_require__.e(5870), __webpack_require__.e(4271), __webpack_require__.e(8316), __webpack_require__.e(2850), __webpack_require__.e(3584), __webpack_require__.e(2240), __webpack_require__.e(8329), __webpack_require__.e(8408)]).then(__webpack_require__.bind(__webpack_require__, 86259));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86259)
            ];
        }
    }
});
var CartMenuV2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(9866), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(7447), __webpack_require__.e(1888), __webpack_require__.e(615), __webpack_require__.e(6748), __webpack_require__.e(6665), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(6381), __webpack_require__.e(4980), __webpack_require__.e(5870), __webpack_require__.e(4271), __webpack_require__.e(1995), __webpack_require__.e(1620), __webpack_require__.e(8316), __webpack_require__.e(2850), __webpack_require__.e(3584), __webpack_require__.e(2240), __webpack_require__.e(4341), __webpack_require__.e(2670)]).then(__webpack_require__.bind(__webpack_require__, 98581));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98581)
            ];
        }
    }
});
var CategoriesLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(7447), __webpack_require__.e(1888), __webpack_require__.e(615), __webpack_require__.e(6748), __webpack_require__.e(3346), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(6381), __webpack_require__.e(4980), __webpack_require__.e(5870), __webpack_require__.e(4271), __webpack_require__.e(6535), __webpack_require__.e(695), __webpack_require__.e(3765)]).then(__webpack_require__.bind(__webpack_require__, 16984));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16984)
            ];
        }
    }
});
var NextOpenDate = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3912).then(__webpack_require__.bind(__webpack_require__, 53912));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53912)
            ];
        }
    }
});
var NoMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3859).then(__webpack_require__.bind(__webpack_require__, 83859));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83859)
            ];
        }
    }
});
var Options = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(9866), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(7447), __webpack_require__.e(1888), __webpack_require__.e(6665), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(6381), __webpack_require__.e(4980), __webpack_require__.e(1995), __webpack_require__.e(1620), __webpack_require__.e(1302)]).then(__webpack_require__.bind(__webpack_require__, 97744));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97744)
            ];
        }
    }
});
var DeliveryHeaderMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(9866), __webpack_require__.e(5990), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(6665), __webpack_require__.e(1995), __webpack_require__.e(1620), __webpack_require__.e(3279)]).then(__webpack_require__.bind(__webpack_require__, 18759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18759)
            ];
        }
    }
});
var CreateAddress = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(9866), __webpack_require__.e(5990), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(6665), __webpack_require__.e(1995), __webpack_require__.e(1620), __webpack_require__.e(4458)]).then(__webpack_require__.bind(__webpack_require__, 21620));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21620)
            ];
        }
    },
    ssr: false
});
function Order(props) {
    var ref6, ref1, ref2;
    var website = props.website, design = props.design, productId = props.productId, categories = props.categories, page = props.page, componentIdToSsrProps = props.componentIdToSsrProps;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,useMyOrderPreferencesWithDefault/* default */.Z)(website), preferences = ref3.preferences, loading = ref3.loading;
    var layout = (0,useLayout/* default */.Z)(website);
    var ref4 = _slicedToArray((0,useSessionStorageState/* default */.Z)("onTable"), 1), onTable = ref4[0];
    var productsLayout = (0,useProductsLayout/* default */.Z)(website);
    var addressModal = router.query.addressModal;
    var ref5 = (0,react.useState)(!!addressModal), modalOpen = ref5[0], setModalOpen = ref5[1];
    (0,react.useEffect)(function() {
        (0,events.sendEvent)(events.EVENTS.pageView.order, {});
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.addressModal) {
            router.replace({
                pathname: "/pedir",
                query: {}
            });
        }
    }, [
        (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.addressModal
    ]);
    if (!preferences || loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).loadingContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsContent_Loading/* default */.Z, {
                    fullScreen: layout === "v2"
                })
            })
        });
    }
    var menuId = preferences.menuId;
    if (!menuId) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMenu, {});
    if (!website.deliveryTypes) return null;
    if (!website.deliveryTypes.length) return null;
    var nextOpenDate = /*#__PURE__*/ (0,jsx_runtime.jsx)(NextOpenDate, {
        deliverAt: preferences.deliverAt,
        store: preferences.store
    });
    var productCardDesign = design === null || design === void 0 ? void 0 : design.design.productCardDesign;
    var products = productsLayout === "categories" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesLayout, {
        website: website,
        menuId: menuId,
        preferences: preferences,
        productCardDesign: productCardDesign,
        storeId: preferences === null || preferences === void 0 ? void 0 : (ref1 = preferences.store) === null || ref1 === void 0 ? void 0 : ref1._id,
        deliverAt: preferences === null || preferences === void 0 ? void 0 : preferences.deliverAt
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LongOrCompactLayout, {
            website: website,
            productsLayout: productsLayout,
            layout: layout,
            menuId: menuId,
            loading: loading,
            nextOpenDate: nextOpenDate,
            preferences: preferences,
            productCardDesign: productCardDesign,
            preloadedCategories: categories,
            storeId: preferences === null || preferences === void 0 ? void 0 : (ref2 = preferences.store) === null || ref2 === void 0 ? void 0 : ref2._id,
            deliverAt: preferences === null || preferences === void 0 ? void 0 : preferences.deliverAt
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useOrderPreferences/* OrderPreferencesContext.Provider */.F.Provider, {
            value: preferences,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartLoadingContext/* CartLoadingProvider */.RI, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).container,
                    children: [
                        modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateAddress, {
                            isOpen: modalOpen,
                            onClose: function() {
                                return setModalOpen(false);
                            }
                        }),
                        onTable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnTableModal, {}) : null,
                        page ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                            pageId: page._id,
                            page: page,
                            componentIdToSsrProps: componentIdToSsrProps
                        }) : null,
                        layout === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {
                                    website: website,
                                    preferences: preferences,
                                    layout: layout
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryHeaderMobile, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).mobileMarginTop
                                })
                            ]
                        }) : null,
                        layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMenuV2, {
                            loading: loading,
                            website: website,
                            preferences: preferences,
                            layout: layout
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            children: [
                                preferences.store && layout !== "v2" ? nextOpenDate : null,
                                layout === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
                                        children: products
                                    })
                                }) : null,
                                layout === "v1" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-xs-12 col-sm-6 col-md-4 last-sm",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                                                    preferences: preferences,
                                                    website: website,
                                                    layout: layout
                                                }),
                                                layout === "mobile" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {
                                                    website: website,
                                                    preferences: preferences,
                                                    layout: layout
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsContent_Loading/* default */.Z, {}),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-xs-12 col-sm-6 col-md-8",
                                                children: products
                                            })
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsContent_Loading/* default */.Z, {
                                fullScreen: true
                            }),
                            children: products
                        }) : null,
                        productId ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta, {
                            website: website
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {})
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/_sites/[mobileOrDesktop]/[hostname]/order/index.tsx









var __N_SSG = true;
/**
 * Important note:
 * This page is shared between multiple routes (order, category, product and conversational-commerce routes).
 * To enable this magic, read src/helpers/middleware/sharedPages/index.ts
 */ function OrderPage(props) {
    var router = (0,useSharedPageRewriteHelper/* default */.Z)("productId", getProductIdFromOrderUrl);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SsgFallback/* default */.Z, {});
    }
    if (!props.website) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWebsite["default"], {});
    }
    if (props.website.isDeactivatedByDebt) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivatedByDebt/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AbstractLayout/* default */.Z, {
        LayoutComponent: Website["default"],
        initialData: props.initialData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Order, {
            page: props.page,
            componentIdToSsrProps: props.componentIdToSsrProps,
            website: props.website,
            design: props.design,
            productId: Array.isArray(router.query.productId) ? router.query.productId[0] : router.query.productId
        })
    });
};


/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 80805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2k40sP--bs7-ORleL6riGA","loading":"_2eozYEUmcZzMsjXiI6UIu6"};

/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dzszu0edT56nvw27R-vYR loadingGlow"};

/***/ }),

/***/ 43469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uvgfwBWaWQqFyLab9Dtip","image":"hS9SabcUKdHLsU7xUWYeA","title":"_3zsZZ1G9oclG4rKZNszc97","logo":"_1EDR5Wb9Y0TBlQji0Ya33U"};

/***/ }),

/***/ 43872:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2bEeEQNpv9yvXBBvEmpfOH orderMainContainer","mobileMarginTop":"_1Y1ns8DNZhwPZ5az9jD21B","loadingContainer":"_3-H9UEsWuWJy9oTqpF_DKH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,1470,4078,1964,8821,1293,4356,6970,937,4495,6344,151,9774,2888,179], function() { return __webpack_exec__(9695); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);